import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = ({
  smallMargin,
  center,
  inline
}) => {
  const classes = classNames({
    spinner: true,
    'spinner--small-margin': smallMargin,
    'spinner--center': center,
    'spinner--inline': inline
  }); // const classes = smallMargin ? 'spinner spinner--small-margin' : 'spinner';

  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner__rectangle rect1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__rectangle rect2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__rectangle rect3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__rectangle rect4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spinner__rectangle rect5"
  }));
};

Spinner.propTypes = {
  smallMargin: PropTypes.bool,
  center: PropTypes.bool,
  inline: PropTypes.bool
}; // Used when in Modal context

Spinner.defaultProps = {
  showCloseIcon: false,
  shouldCloseOnOverlayClick: false,
  hideButtons: true,
  class: 'modal--spinner'
};
export default Spinner;